/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Observable } from 'rxjs';
import { EditableCellAccessor, GridModel, GridState } from './grid-state.interfaces';

export function createGridModel(state: GridState<any>): GridModel {
  return new StateBasedGridModel(state);
}

export class StateBasedGridModel implements GridModel {
  constructor(private state: GridState<any>) {
  }

  get rowData(): Observable<any[]> {
    return this.state.rowData;
  }

  get editable(): Observable<boolean> {
    return this.state.editable;
  }

  getCellAccessor(name: string): EditableCellAccessor {
    return {
      name,
      setValue: (params, _, newValue) => this.state.setValue(params.data, name, newValue),
      getState: (params) => this.state.getState(params.data, name),
      getValue: (state) => this.state.getValue(name, state),
      validate: (params, value) => this.state.validate(params.data, name, value),
      isEditable: (params) => this.state.isEditable(params.data, name),
      isRequired: (params) => this.state.isRequired(params.data, name),
      equals: this.state.valueEquals ? this.state.valueEquals.bind(this.state, name) : void 0,
    };
  }

  getEntityId(data: any): any {
    return this.state.getEntityId(data);
  }

  setData(data: any): void {
    this.state.setData(data);
  }
}
